import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=7fdfc81b&scoped=true&"
import script from "./Assign.vue?vue&type=script&lang=js&"
export * from "./Assign.vue?vue&type=script&lang=js&"
import style0 from "./Assign.vue?vue&type=style&index=0&id=7fdfc81b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdfc81b",
  null
  
)

export default component.exports